export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            关于777影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            致力于为全国影迷打造最便捷的影视导航平台
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/60">
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-4">
              <p>
                <strong className="text-foreground-900">777影院</strong>成立于2020年，是一个专注于影视资源索引与导航的综合性平台。我们深知用户在寻找影视资源时面临的困扰——域名繁多、真假难辨、入口不稳定。为此，我们整合了7777影院、777777影院、77777影院等所有数字变体域名，打造了统一的官方导航入口，让每一位影迷都能安全、快速地找到正确的观影通道。
              </p>
              <p>
                平台涵盖了电影、电视剧、综艺、动漫、纪录片等全品类影视内容，资源总量超过两万部，覆盖国内外主流和精品小众作品。我们拥有一支专业的运营团队，每日对片源进行更新维护，确保内容的新鲜度和可用性。无论是热映大片、经典老片，还是小众佳作、冷门好剧，在777影院都能找到属于你的那份观影快乐。
              </p>
              <p>
                作为纯导航服务平台，777影院始终坚持<strong className="text-foreground-900">免费、纯净、安全</strong>的运营理念。我们不设置任何付费门槛，不做弹窗广告骚扰，不收集用户隐私信息。我们的价值在于帮助用户用最短的路径找到最优质的影视内容，让观影回归纯粹。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">5年+</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">7x24</div>
                <div className="text-xs text-foreground-500 mt-1">持续维护</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}